import imageData from './imageData'
import value from './value'
import Hammer from 'hammerjs'
import Vue from 'vue'
import updateImageData from './updateImageData'

let handling = false
let hammer = null
async function handleTouchEvent () {
  if (this.internalImageData && !this.disabled && !this.readonly && !handling) {
    handling = true
    await Vue.nextTick()
    const { toBindForPanEndEvent: el } = this.$refs
    hammer = new Hammer.Manager(el, {
      inputClass: Hammer.TouchInput
    })
    hammer.add(new Hammer.Pan({
      direction: Hammer.DIRECTION_ALL
    }))
    hammer.on('panend', () => {
      Vue.nextTick(() => {
        this.panend = true
      })
    })
  } else {
    if (hammer) {
      hammer.destroy()
      hammer = null
    }
    handling = false
  }
}

export default {
  imageData,
  value,
  disabled: {
    immediate: true,
    handler: handleTouchEvent
  },
  readonly: {
    immediate: true,
    handler: handleTouchEvent
  },

  backgroundColor: updateImageData,
  panend: updateImageData,
  scaling: updateImageData,
  debounce: updateImageData,
  flippedHorizontally: updateImageData,
  flippedVertically: updateImageData,
  imageFormat: updateImageData,
  imageWidth: updateImageData,
  $imageWidth: updateImageData,
  imageHeight: updateImageData,
  imageQuality: updateImageData,
  internalImageData: function () {
    handleTouchEvent.bind(this)()
    updateImageData.bind(this)
  },
  rotated: updateImageData
}
